import { SerialNumberCellRenderer } from './serialNumber';

export const AgGridCellRenderer = {
  SerialNumber: SerialNumberCellRenderer
};
